import { Injectable } from '@angular/core';
import { BackendService } from './backend.service';

@Injectable()
export class SupportService {

  constructor(private backendService: BackendService) {}


  sendSupportMessage(subject:string, message: string):Promise<any>{
    return this.backendService.post("support", {
      subject,
      message
    })
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/services/support.service.ts